import { useEffect, useState } from "react";
import type { ReactNode } from "react";
import { ListContainer } from "./ListContainer";

// ReactDnD allows different droppable components to share the same item type so you can drag and drop item from one to the other.
// But for the sake of reusability and independence of sortable list component, each list have different item type.
const generateUniqueItemType = () => {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters after the decimal.
  return `_${Math.random().toString(36).substr(2, 9)}`;
};

export type DraggableItem = {
  id: string | number;
  content: ReactNode;
};

export type DraggableItemIdentifier = {
  index: number;
  id: string | number;
};

type SortableListProp = {
  className?: string;
  items: DraggableItem[];
  onSwapItems?: (dragStartItem: DraggableItemIdentifier, dropTargetItem: DraggableItemIdentifier) => void;
  renderPreview?: (item: DraggableItem, index: number) => ReactNode;
};

// A wrapper to provide the shared DnDProvider for all the instances of SortableList components.
export function SortableList(props: SortableListProp) {
  const [itemType, setItemType] = useState<undefined | string>(undefined);

  useEffect(() => {
    setItemType(generateUniqueItemType());
  }, []);

  if (!itemType) {
    return <></>;
  }
  return (
    <ListContainer
      className={props.className}
      itemType={itemType}
      items={props.items}
      onDropItem={(dragIndex, dropIndex, dragItemId, dropItemId) => {
        if (props.onSwapItems) {
          props.onSwapItems({ index: dragIndex, id: dragItemId }, { index: dropIndex, id: dropItemId });
        }
      }}
      renderPreview={props.renderPreview}
    />
  );
}
